import {
  AdRequestSourceManager,
  DefaultAdRequestSourceManager
} from 'core/adRequestSource/AdRequestSourceManager';
import { useCallAPI } from 'hooks/useCallAPI';
import { useEffect, useState } from 'react';

const adRequestSourceManager: AdRequestSourceManager =
  new DefaultAdRequestSourceManager();
export const useStoreNumOptions = (
  channelGroupId: number | undefined,
  beaconConnectionId: number | undefined
): {
  loading: boolean;
  storeNumOptions: SelectOptions[];
} => {
  const { loading, callAPIs } = useCallAPI();
  const [storeNumOptions, setStoreNumOptions] = useState<SelectOptions[]>([]);

  useEffect(() => {
    if (!channelGroupId || !beaconConnectionId) {
      return;
    }

    callAPIs(
      [
        () =>
          adRequestSourceManager.getStoreNumOptions(
            channelGroupId,
            beaconConnectionId
          )
      ],
      setStoreNumOptions
    );
  }, [channelGroupId, beaconConnectionId, callAPIs]);

  return {
    loading,
    storeNumOptions
  };
};
